import { ISO6391 } from "./iso6391";
export function IsLocalizable(item) {
    return item instanceof LocalString;
}
export function DeserializeLocalizableString(input) {
    if (!input) {
        return undefined;
    }
    if (input["contents"]) {
        return input;
    }
    var ls = new LocalString();
    ls.deserialize(input);
    return ls;
}
export function GetLocalizableStringValue(str, code) {
    return str instanceof String ? str : str.getValue(code);
}
export class LocalString {
    constructor() {
        this.contents = new Map();
    }
    tryAdd(code, value) {
        if (ISO6391.validate(code)) {
            this.contents.set(code, value);
            return true;
        }
        return false;
    }
    deserialize(input) {
        this.contents.clear();
        for (var p in input.getOwnPropertyNames()) {
            if (ISO6391.validate(p)) {
                this.contents.set(p, input[p]);
            }
        }
    }
    getValue(code) {
        if (code) {
            var v = this.contents.get(code);
            if (v || code == LocalString.DefaultCode) {
                return v;
            }
        }
        return this.contents.get(LocalString.DefaultCode);
    }
}
LocalString.DefaultCode = "en";
//# sourceMappingURL=localizable.js.map